import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const FullName = () => {
  const { setFullName } = useActions(sceneLogic)
  const { fullName, errors } = useValues(sceneLogic)

  const handleChangeFullName = event => setFullName(event.target.value)

  return (
    <div className={`form-element full-width${errors.fullName ? ' has-errors' : ''}`}>
      <label htmlFor='full-name-input' className='block'>
        {I18n.t('react.request.request.full_name')}
      </label>
      <input
        id='full-name-input'
        type='text'
        value={fullName}
        className='input-text inline'
        onChange={handleChangeFullName}
      />
      {errors.fullName && <div className='simple-error'>{errors.fullName}</div>}
    </div>
  )
}

export default FullName
